import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  progress: {
    width: '10% !important',
    height: 'auto !important',
  },
};

const FixedCircularProgress = (props) => {
  const { classes } = props;
  return (
    <div className="full-height centered-flex-container" style={{ width: '100%' }}>
      <CircularProgress className={classes.progress} thickness={2} />
    </div>
  );
};

FixedCircularProgress.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FixedCircularProgress);



// WEBPACK FOOTER //
// ./src/components/FixedCircularProgress.jsx